import React, { useState } from "react";
import { Card as RawCard } from "@/components/ui/card";
import { Button as RawButton } from "@/components/ui/button";
import { Heart, CircleDot, Ship, Car, X } from "lucide-react";
import { motion } from "framer-motion";

const DUMMY_FAVORITES = [
  {
    id: "1",
    item_type: "golf_course",
    item_id: "gc_001",
    item_name: "Royal Palm Golf Club",
    item_details: { location: "Dubai, UAE" },
  },
  {
    id: "2",
    item_type: "ferry_route",
    item_id: "fr_001",
    item_name: "Marina to Palm Jumeirah",
    item_details: { location: "Dubai Marina" },
  },
  {
    id: "3",
    item_type: "land_transport",
    item_id: "lt_001",
    item_name: "Downtown Express Shuttle",
    item_details: { location: "Downtown Dubai" },
  },
  {
    id: "4",
    item_type: "golf_course",
    item_id: "gc_002",
    item_name: "Emirates Golf Club",
    item_details: { location: "Emirates Hills, Dubai" },
  },
  {
    id: "5",
    item_type: "ferry_route",
    item_id: "fr_002",
    item_name: "Deira to Bur Dubai Abra",
    item_details: { location: "Dubai Creek" },
  },
];

export default function FavoritesSection() {
  const Button = /** @type {React.ComponentType<any>} */ (RawButton);
  const Card = /** @type {React.ComponentType<any>} */ (RawCard);

  const [favorites, setFavorites] = useState(DUMMY_FAVORITES);

  /**
   * @param {string} favoriteId
   */
  const handleRemove = (favoriteId) => {
    if (window.confirm("Remove this item from favorites?")) {
      setFavorites((prev) => prev.filter((f) => f.id !== favoriteId));
    }
  };

  /**
   * @param {'golf_course'|'ferry_route'|'land_transport'|string} type
   * @returns {React.ReactNode}
   */
  const getIcon = (type) => {
    switch (type) {
      case "golf_course":
        return <CircleDot className="h-5 w-5 text-emerald-600" />;
      case "ferry_route":
        return <Ship className="h-5 w-5 text-blue-600" />;
      case "land_transport":
        return <Car className="h-5 w-5 text-orange-600" />;
      default:
        return <Heart className="h-5 w-5 text-red-600" />;
    }
  };

  /**
   * @param {'golf_course'|'ferry_route'|'land_transport'|string} type
   * @returns {string}
   */
  const getTypeLabel = (type) => {
    switch (type) {
      case "golf_course":
        return "Golf Course";
      case "ferry_route":
        return "Ferry Route";
      case "land_transport":
        return "Land Transport";
      default:
        return type;
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Card className="p-6 bg-white border border-gray-100">
        <div className="flex items-center gap-2 mb-6">
          <Heart className="h-6 w-6 text-red-600" />
          <h2 className="text-2xl font-bold text-[#0B2421]">My Favorites</h2>
        </div>

        <p className="mb-6 text-gray-500">
          Quick access to your favorite courses, routes, and services.
        </p>

        <div className="text-center py-12 border-2 border-dashed border-gray-200 rounded-lg">
          <Heart className="h-12 w-12 text-red-500 mx-auto mb-3" />
          <h3 className="text-lg font-semibold text-[#0B2421] mb-2">
            No favorites yet
          </h3>
          <p className="text-gray-500">
            Start adding your favorite courses and routes to access them
            quickly.
          </p>
        </div>
        {/* {favorites.length === 0 ? (
          <div className="text-center py-12 border-2 border-dashed border-gray-200 rounded-lg">
            <Heart className="h-12 w-12 text-red-500 mx-auto mb-3" />
            <h3 className="text-lg font-semibold text-[#0B2421] mb-2">
              No favorites yet
            </h3>
            <p className="text-gray-500">
              Start adding your favorite courses and routes to access them quickly.
            </p>
          </div>
        ) : (
          <div className="space-y-3">
            {favorites.map((favorite, index) => (
              <motion.div
                key={favorite.id}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3, delay: index * 0.05 }}
                className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <div className="flex items-center gap-3 flex-1">
                  <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-sm">
                    {getIcon(favorite.item_type)}
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">{favorite.item_name}</h3>
                    <p className="text-sm text-gray-600">
                      {getTypeLabel(favorite.item_type)}
                      {favorite.item_details?.location && ` • ${favorite.item_details.location}`}
                    </p>
                  </div>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => handleRemove(favorite.id)}
                  className="text-red-600 hover:text-red-700 hover:bg-red-50"
                >
                  <X className="h-4 w-4" />
                </Button>
              </motion.div>
            ))}
          </div>
        )} */}
      </Card>
    </motion.div>
  );
}
